/*@ngInject*/
const RangeModalController = function ($rootScope, $scope, $uibModalInstance, $window, coreConstant, options, coreMediator, currentUserModel, localization, loadingBarHandler) {

    localization.getTranslations().then(function (translations) {

        $scope.title = _.get(translations, 'rangeModal.title');
        $scope.description = options.description !== null ? options.description : _.get(translations, 'rangeModal.description');
        if (options.batch) {
            $scope.description = _.replace($scope.description, '${batch}', options.batch);
        }
        $scope.cancelButton = _.get(translations, 'rangeModal.cancelButton');
        $scope.okButton = _.get(translations, 'rangeModal.okButton');
        $scope.minPlaceHolder = _.get(translations, 'rangeModal.minPlaceHolder');
        $scope.maxPlaceHolder = _.get(translations, 'rangeModal.maxPlaceHolder');

        $scope.viewModel = {
            start: options.min ? options.min : 1,
            end: options.batch ? Math.min(options.max, options.batch) : options.max
        };

        $scope.onBlur = function () {
            if ($scope.viewModel.start && $scope.viewModel.start < options.min) {
                $scope.viewModel.start = options.min;
            }
            if ($scope.viewModel.start && $scope.viewModel.start > options.max) {
                $scope.viewModel.start = options.max;
            }

            if ($scope.viewModel.end && $scope.viewModel.end < options.min) {
                $scope.viewModel.end = options.min;
            }
            if ($scope.viewModel.end < $scope.viewModel.start) {
                $scope.viewModel.end = $scope.viewModel.start + options.batch;
            }
            if ($scope.viewModel.end && $scope.viewModel.end > options.max) {
                $scope.viewModel.end = options.max;
            }
            if (options.batch && ($scope.viewModel.end - $scope.viewModel.start + 1) > options.batch) {
                $scope.viewModel.end = $scope.viewModel.start + options.batch - 1;
            }
        };

        $scope.onConfirm = function () {
            options.urlFunction($scope.viewModel).then((url) => {
                $window.open(url, '_blank');
            });
            $uibModalInstance.close($scope.viewModel);
        };

        $scope.onCancel = function () {
            $uibModalInstance.close();
        };

        $scope.canEnableConfirmButton = function () {
            return !_.isNil($scope.viewModel.start) && !_.isNil($scope.viewModel.end);
        };

        $scope.init();
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission-grid').controller('rangeModalController', RangeModalController);
